import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AskQuestionComponent } from './ask-question.component';

@NgModule({
  declarations: [AskQuestionComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [AskQuestionComponent],
})
export class AskQuestionModule {}
